export default "/images/vendor/flag-icons/flags/1x1/um.svg?a26c7f8b7b44e4726edbb21082df29c9";